import * as React from "react"
import type { SVGProps } from "react"
const SvgAnnouncement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M21 13h-2a1 1 0 0 1-.71-.29A1 1 0 0 1 18 12q0-.42.29-.71.29-.3.71-.29h2q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29m-4.4 3.8a1 1 0 0 1 .65-.4q.4-.05.75.2l1.6 1.2q.35.25.4.65t-.2.75a1 1 0 0 1-.65.4q-.4.05-.75-.2l-1.6-1.2a1 1 0 0 1-.4-.65q-.05-.4.2-.75m3-10.6L18 7.4q-.34.25-.75.2a1 1 0 0 1-.65-.4 1 1 0 0 1-.2-.75 1 1 0 0 1 .4-.65l1.6-1.2q.35-.25.75-.2t.65.4.2.75a1 1 0 0 1-.4.65M5 15H4q-.82 0-1.41-.59-.6-.59-.59-1.41v-2q0-.82.59-1.41Q3.18 8.99 4 9h4l3.47-2.1q.51-.3 1.02 0t.51.88v8.45q0 .57-.51.87t-1.02 0L8 15H7v3q0 .42-.29.71-.29.3-.71.29a1 1 0 0 1-.71-.29A1 1 0 0 1 5 18zm6-.55v-4.9L8.55 11H4v2h4.55zm3 .9v-6.7A4.6 4.6 0 0 1 15.5 12q0 1.02-.41 1.89A5 5 0 0 1 14 15.35" />
  </svg>
)
export default SvgAnnouncement
